import { createServiceStateApi } from './_serviceState';
const api = createServiceStateApi('compliance');
export const { getAllState, getState, patchState, putState, removeState } = api;
export default api;
